import React from "react"
import AuthBackground from "../components/auth/authBackground"
import AuthCard from "../components/auth/authCard"
import ClientLoginForm from "../components/auth/clientLoginForm"
import RecaptchaProvider from "../components/recaptcha/RecaptchaProvider"

const ClientLoginPage = () => {
  return (
    <RecaptchaProvider>
      <div className="container-fluid relative h-screen mx-auto flex justify-center items-center bg-cream max-md:text-sm">
        <AuthCard>
          <ClientLoginForm />
        </AuthCard>
        <AuthBackground />
      </div>
    </RecaptchaProvider>
  )
}

export default ClientLoginPage
